import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contentId", "contentType", "contentName", "portalId", "assignmentIds", "children", "textAlign", "tooltipPlacement", "render", "use", "onClick"];
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { ContentAssignModalTrigger } from './ContentAssignModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentAssignButton = _ref => {
  let {
      contentId,
      contentType,
      contentName,
      portalId,
      assignmentIds,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlistAssignments.assign"
      }),
      textAlign = 'center',
      tooltipPlacement,
      render,
      use = 'tertiary-light',
      onClick
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = useCallback(() => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: assignmentIds ? 'content-due-date-update' : 'assign-content-clicked',
      contentId,
      contentType,
      portalId
    });
  }, [assignmentIds, contentId, contentType, portalId]);
  return /*#__PURE__*/_jsx(ContentAssignModalTrigger, {
    assignmentIds: assignmentIds,
    contentId: contentId,
    contentName: contentName,
    contentType: contentType,
    portalId: portalId,
    renderTrigger: ({
      openModal
    }) => {
      const handleClickWithAnalytics = () => {
        handleClick();
        onClick === null || onClick === void 0 || onClick();
        openModal();
      };
      if (render) {
        return render(handleClickWithAnalytics);
      }
      return /*#__PURE__*/_jsx(Tooltip, {
        placement: tooltipPlacement,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.playlistAssignments.assign"
        }),
        children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
          onClick: handleClickWithAnalytics,
          use: use,
          children: /*#__PURE__*/_jsx(View, {
            inlineSize: "100%",
            textAlign: textAlign,
            children: children
          })
        }))
      });
    }
  });
};